/**
 * ANQ.ContentServiceManagement.API 
 * Content Service Mgt API
 *
 * OpenAPI spec version: v1
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { FetchShortCodesDto } from '../model/fetchShortCodesDto';
import { ProblemDetails } from '../model/problemDetails';
import { ShortCodeServiceProviderMap } from '../model/shortCodeServiceProviderMap';
import { ShortCodeValidateDto } from '../model/shortCodeValidateDto';
import { Shortcode } from '../model/shortcode';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ShortCodeService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param ShortCodeId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiShortCodeDeleteDelete(ShortCodeId?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiShortCodeDeleteDelete(ShortCodeId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiShortCodeDeleteDelete(ShortCodeId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiShortCodeDeleteDelete(ShortCodeId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (ShortCodeId !== undefined && ShortCodeId !== null) {
            queryParameters = queryParameters.set('ShortCodeId', <any>ShortCodeId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/api/ShortCode/Delete`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param ShortCodeServiceProviderMapId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiShortCodeDeleteShortCodeServiceProviderMapDelete(ShortCodeServiceProviderMapId?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiShortCodeDeleteShortCodeServiceProviderMapDelete(ShortCodeServiceProviderMapId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiShortCodeDeleteShortCodeServiceProviderMapDelete(ShortCodeServiceProviderMapId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiShortCodeDeleteShortCodeServiceProviderMapDelete(ShortCodeServiceProviderMapId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (ShortCodeServiceProviderMapId !== undefined && ShortCodeServiceProviderMapId !== null) {
            queryParameters = queryParameters.set('ShortCodeServiceProviderMapId', <any>ShortCodeServiceProviderMapId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/api/ShortCode/DeleteShortCodeServiceProviderMap`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param ServiceProviderId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiShortCodeGetMapByServiceProviderIdGet(ServiceProviderId?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ShortCodeServiceProviderMap>>;
    public apiShortCodeGetMapByServiceProviderIdGet(ServiceProviderId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ShortCodeServiceProviderMap>>>;
    public apiShortCodeGetMapByServiceProviderIdGet(ServiceProviderId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ShortCodeServiceProviderMap>>>;
    public apiShortCodeGetMapByServiceProviderIdGet(ServiceProviderId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (ServiceProviderId !== undefined && ServiceProviderId !== null) {
            queryParameters = queryParameters.set('ServiceProviderId', <any>ServiceProviderId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ShortCodeServiceProviderMap>>('get',`${this.basePath}/api/ShortCode/GetMapByServiceProviderId`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param shortCode 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiShortCodeGetMapByShortCodeGet(shortCode?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ShortCodeServiceProviderMap>>;
    public apiShortCodeGetMapByShortCodeGet(shortCode?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ShortCodeServiceProviderMap>>>;
    public apiShortCodeGetMapByShortCodeGet(shortCode?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ShortCodeServiceProviderMap>>>;
    public apiShortCodeGetMapByShortCodeGet(shortCode?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (shortCode !== undefined && shortCode !== null) {
            queryParameters = queryParameters.set('shortCode', <any>shortCode);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ShortCodeServiceProviderMap>>('get',`${this.basePath}/api/ShortCode/GetMapByShortCode`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param shortCode 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiShortCodeGetShortCodeByShortCodeGet(shortCode?: string, observe?: 'body', reportProgress?: boolean): Observable<Shortcode>;
    public apiShortCodeGetShortCodeByShortCodeGet(shortCode?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Shortcode>>;
    public apiShortCodeGetShortCodeByShortCodeGet(shortCode?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Shortcode>>;
    public apiShortCodeGetShortCodeByShortCodeGet(shortCode?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (shortCode !== undefined && shortCode !== null) {
            queryParameters = queryParameters.set('shortCode', <any>shortCode);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Shortcode>('get',`${this.basePath}/api/ShortCode/GetShortCodeByShortCode`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param OperatorId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiShortCodeGetShortCodesByOperatorIdGet(OperatorId?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiShortCodeGetShortCodesByOperatorIdGet(OperatorId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiShortCodeGetShortCodesByOperatorIdGet(OperatorId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiShortCodeGetShortCodesByOperatorIdGet(OperatorId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (OperatorId !== undefined && OperatorId !== null) {
            queryParameters = queryParameters.set('OperatorId', <any>OperatorId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('get',`${this.basePath}/api/ShortCode/GetShortCodesByOperatorId`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param shortCode 
     * @param operatorId 
     * @param skip 
     * @param take 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiShortCodeGetShortCodesSkipTakeGet(shortCode?: string, operatorId?: string, skip?: number, take?: number, observe?: 'body', reportProgress?: boolean): Observable<FetchShortCodesDto>;
    public apiShortCodeGetShortCodesSkipTakeGet(shortCode?: string, operatorId?: string, skip?: number, take?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<FetchShortCodesDto>>;
    public apiShortCodeGetShortCodesSkipTakeGet(shortCode?: string, operatorId?: string, skip?: number, take?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<FetchShortCodesDto>>;
    public apiShortCodeGetShortCodesSkipTakeGet(shortCode?: string, operatorId?: string, skip?: number, take?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (shortCode !== undefined && shortCode !== null) {
            queryParameters = queryParameters.set('shortCode', <any>shortCode);
        }
        if (operatorId !== undefined && operatorId !== null) {
            queryParameters = queryParameters.set('operatorId', <any>operatorId);
        }
        if (skip !== undefined && skip !== null) {
            queryParameters = queryParameters.set('skip', <any>skip);
        }
        if (take !== undefined && take !== null) {
            queryParameters = queryParameters.set('take', <any>take);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<FetchShortCodesDto>('get',`${this.basePath}/api/ShortCode/GetShortCodesSkipTake`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiShortCodeInsertShortCodeListPost(body?: Array<Shortcode>, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiShortCodeInsertShortCodeListPost(body?: Array<Shortcode>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiShortCodeInsertShortCodeListPost(body?: Array<Shortcode>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiShortCodeInsertShortCodeListPost(body?: Array<Shortcode>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/api/ShortCode/InsertShortCodeList`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiShortCodeInsertShortCodeServiceProviderMapPost(body?: Array<ShortCodeServiceProviderMap>, observe?: 'body', reportProgress?: boolean): Observable<Array<ShortCodeServiceProviderMap>>;
    public apiShortCodeInsertShortCodeServiceProviderMapPost(body?: Array<ShortCodeServiceProviderMap>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ShortCodeServiceProviderMap>>>;
    public apiShortCodeInsertShortCodeServiceProviderMapPost(body?: Array<ShortCodeServiceProviderMap>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ShortCodeServiceProviderMap>>>;
    public apiShortCodeInsertShortCodeServiceProviderMapPost(body?: Array<ShortCodeServiceProviderMap>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Array<ShortCodeServiceProviderMap>>('post',`${this.basePath}/api/ShortCode/InsertShortCodeServiceProviderMap`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiShortCodeValidateMapPost(body?: Array<ShortCodeServiceProviderMap>, observe?: 'body', reportProgress?: boolean): Observable<Array<string>>;
    public apiShortCodeValidateMapPost(body?: Array<ShortCodeServiceProviderMap>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<string>>>;
    public apiShortCodeValidateMapPost(body?: Array<ShortCodeServiceProviderMap>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<string>>>;
    public apiShortCodeValidateMapPost(body?: Array<ShortCodeServiceProviderMap>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Array<string>>('post',`${this.basePath}/api/ShortCode/ValidateMap`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiShortCodeValidateShortCodesPost(body?: Array<Shortcode>, observe?: 'body', reportProgress?: boolean): Observable<Array<ShortCodeValidateDto>>;
    public apiShortCodeValidateShortCodesPost(body?: Array<Shortcode>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ShortCodeValidateDto>>>;
    public apiShortCodeValidateShortCodesPost(body?: Array<Shortcode>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ShortCodeValidateDto>>>;
    public apiShortCodeValidateShortCodesPost(body?: Array<Shortcode>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Array<ShortCodeValidateDto>>('post',`${this.basePath}/api/ShortCode/ValidateShortCodes`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
